class industriesRegister {

    static indutries = null;

    static setIndustries(indutries){
        industriesRegister.indutries = indutries;
        try {
            sessionStorage.setItem('indutries', JSON.stringify(indutries));
        }catch (e) {}
    }

    static getIndustries(){
        try {
            if(sessionStorage.getItem('indutries')){
                return JSON.parse(sessionStorage.getItem('indutries'));
            }else{
                return industriesRegister.indutries;
            }
        }catch (e) {
            return industriesRegister.indutries;
        }
    }

    static removeIndustries(){
        try {
            sessionStorage.removeItem('indutries');
        }catch (e) {}
        industriesRegister.indutries = null;
    }

    //SHORTENER
    static set(indutries){
        industriesRegister.setIndustries(indutries);
    }

    static get(){
        return industriesRegister.getIndustries();
    }

    static remove(){
        industriesRegister.removeIndustries();
    }

}

export {industriesRegister}


// WEBPACK FOOTER //
// ./src/services/industriesRegister.js